{
  "id": "campaign-101",
  "name": "Elegant Lawns",
  "seed": "campaign:101",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....ACCA.....",
    ".....,CC......",
    "....,,CC......",
    "...q..CC..q...",
    "x.....CC.,....",
    ".....CCCC,....",
    "...t.CwwC,t...",
    ".....CwwC.~...",
    "..q..CwwC.~q..",
    ".....CCCC.~...",
    ".t.t..CC..t.t.",
    ".....tCCt.....",
    "..%%..CC..%%..",
    "...%......%...",
    "S............."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 6,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 101,
  "biome": "estate",
  "par": {
    "reel": 6198,
    "push": 5437,
    "selfPropelled": 4956,
    "tractor": 4150,
    "zeroTurn": 3634,
    "fairway": 2659
  },
  "goldTime": {
    "reel": 6198,
    "push": 5437,
    "selfPropelled": 4956,
    "tractor": 4070,
    "zeroTurn": 3558,
    "fairway": 2588
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 17,
      "selfPropelled": 3,
      "tractor": 22,
      "zeroTurn": 0,
      "fairway": 0
    },
    "gold": {
      "reel": 0,
      "push": 17,
      "selfPropelled": 3,
      "tractor": 28,
      "zeroTurn": 34,
      "fairway": 35
    }
  }
}
